module.exports = __webpack_public_path__ + "static/gmail-cfd50b61c5efca9b86f354c49e42ce5c.svg";